import { ActivatedRouteSnapshot, ActivationEnd, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Injectable, OnDestroy } from '@angular/core'
import { filter, take } from 'rxjs/operators'
import { ConfigurationAnalyticsService } from '../services/configurationAnalytics.service'
import { ConfigurationIdResolver } from '../resolvers/configurationId.resolver'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigurationRoute } from '../services/configurationRoute.service'
import { Observable } from 'rxjs'

@UntilDestroy()
@Injectable()
export class StepDatalayerGuard implements CanActivate {
    private configurationId: string
    private route$: Observable<ConfigurationRoute>

    constructor(
        private router: Router,
        private configurationAnalyticsService: ConfigurationAnalyticsService,
        private configurationIdResolver: ConfigurationIdResolver
    ) {
        configurationIdResolver.configurationId$.pipe(untilDestroyed(this)).subscribe(configurationId => {
            this.configurationId = configurationId
        })
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        this.router.events
            .pipe(
                filter<ActivationEnd>(event => event instanceof ActivationEnd),
                filter(event => event.snapshot === route),
                take(1)
            )
            .subscribe(() => {
                this.configurationAnalyticsService.push({
                    name: 'carconfigurator.funnel.step',
                    dealId: this.configurationId,
                })
            })

        return true
    }
}
